"use client";

import { useEffect, useRef } from "react";
import { useSession } from "next-auth/react";

import { clearLoginGracePeriod } from "~/lib/auth-grace-period";
import { terminateSessionAndRedirectToLogin } from "~/lib/client-session";
import {
  shouldTerminateForUnauthorized,
  verifyCustomerSessionWithRetry,
} from "~/lib/verify-customer-session";

/**
 * NextAuth can still show a session while the Henga bearer cookie is invalid.
 * Re-verify against `/api/auth/customer-auth` when the user lands on the home page.
 */
export function HomeSessionCheck() {
  const { status } = useSession();
  const ranForAuthCycle = useRef(false);

  useEffect(() => {
    if (status === "loading") return;
    if (status !== "authenticated") {
      ranForAuthCycle.current = false;
      return;
    }
    if (ranForAuthCycle.current) return;
    ranForAuthCycle.current = true;

    void (async () => {
      try {
        const result = await verifyCustomerSessionWithRetry();
        if (shouldTerminateForUnauthorized(result.unauthorized)) {
          await terminateSessionAndRedirectToLogin();
          return;
        }
        if (!result.unauthorized) {
          clearLoginGracePeriod();
        }
      } catch {
        /* ignore transient network errors */
      }
    })();
  }, [status]);

  return null;
}
